// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"405":"4688a1ff9302663b","888":"0e36b22de8d72c43"}[chunkId] + ".css";
};